/**
 * Unified audit mode (front_json.audit on the AP model):
 * ignore activity mapping, use default answer variants (no `activity` key), save to one table.
 */

export function getAuditFrontConfig(frontJson) {
	const audit = frontJson?.audit;
	return audit && typeof audit === 'object' ? audit : {};
}

export function isUnifiedAuditMode(auditConfig) {
	return String(auditConfig?.mode || '').trim().toLowerCase() === 'unified';
}

export function getUnifiedAuditTableName(auditConfig) {
	const raw = auditConfig?.table;
	if (raw == null) {
		return null;
	}
	if (typeof raw === 'string') {
		return raw.trim() || null;
	}
	if (typeof raw === 'object') {
		const name = raw.name || raw.audit_table_list_name;
		return name != null ? String(name).trim() || null : null;
	}
	return String(raw).trim() || null;
}

export function isDefaultAnswerVariant(option) {
	return option?.activity === undefined || option?.activity === null;
}
